import React from 'react'

const Title = ({title}) => {
  return (
    <div className='main-title'>
      <h3>{title}</h3>
    </div>
  )
}

export default Title
